module.exports = __webpack_public_path__ + "img/lineup29@2x.510f7534.png";